/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};


/* ================ SLATE ================ */
window.gravity = window.gravity || {};
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// gravity functions
window.gravity = window.gravity || {};

gravity.cacheSelectors = function () {
  gravity.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

gravity.init = function () {
  $(document).foundation();

  FastClick.attach(document.body);
  gravity.cacheSelectors();
  gravity.loginForms();

  
};

gravity.cartSidebarInit = function () {
  
    var cartScrollTop = 0;
    cartSidebar = new Foundation.OffCanvas($('#cartSidebar'))
    $('#cartSidebar').on('opened.zf.offcanvas', function() {
      cartScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      $('body').css({
        position: 'fixed',
        top: -cartScrollTop + 'px',
        width: '100%',
        overflow: 'hidden'
      });
      ajaxCart.load();
    });
    $('#cartSidebar').on('closed.zf.offcanvas', function() {
      $('body').css({
        position: '',
        top: '',
        width: '',
        overflow: ''
      });
      window.scrollTo(0, cartScrollTop);
    });
  
};

gravity.getHash = function () {
  return window.location.hash;
};

gravity.headerInit = function (section) {
  var dropdownMenu = new Foundation.DropdownMenu($('#primary-menu')),
      mobileSidebar = new Foundation.OffCanvas($('#mobileMenuSidebar'));

  gravity.cartSidebarInit();

  $('.gravity-mega-menu').each(function () {
    megaMenu = new Foundation.Dropdown($(this))
  });

  if($('#admin_bar_iframe').length) {
    $('body').addClass('admin-bar-enabled')
  }

  
};

gravity.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      // $addToCartText = $('#AddToCartText');
      $addToCartText = $('EmptyToAllowOverwrites');

  if (variant) {
    if (variant.featured_image) {
       $('#productImages').attr('data-featured-img', variant.featured_image.id);
       gravity.changeFeaturedImg(variant.featured_image.id);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show().removeClass('is-disabled');
    } else {
      // Sold out, disable the submit button, change text, gray quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.show().addClass('is-disabled');
    }

    // Regardless of stock, update the product price
    var startingAtLabel = $productPrice.attr('data-starting-at-label') || '';
    $productPrice
      .attr('data-product-price-cents', variant.price)
      .html( startingAtLabel + '<span class="money money-variant-update">' + Shopify.formatMoney(variant.price, moneyFormat) + '</span>' );
    document.dispatchEvent(new CustomEvent('product:price-updated', {
      detail: {
        price: variant.price,
        variantTitle: variant.title
      }
    }));

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html( '<span class="money money-variant-update">' + Shopify.formatMoney(variant.compare_at_price, moneyFormat) + '</span>')
        .show();
    } else {
      $comparePrice.hide();
    }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.show().addClass('is-disabled');
  }
  if (variant) {
    var form = jQuery('#' + selector.domIdPrefix).closest('form');
    for (var i=0,length=variant.options.length; i<length; i++) {
      var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + escape(variant.options[i]) +'"]');
      if (radioButton.size()) {
        radioButton.get(0).checked = true;
      }
    }
  }
  document.dispatchEvent(new CustomEvent('product:variant-availability-updated', {
    detail: {
      available: !!(variant && variant.available),
      variantId: variant ? variant.id : null
    }
  }));
};

gravity.changeFeaturedImg = function (featuredImgId) {
  var newImg = featuredImgId;
  var newSlideIndex = $('#productImages div[data-img-id="'+newImg+'"]').attr('data-slick-index');
  if(newSlideIndex) {
    $('#productImages').slick('slickGoTo', newSlideIndex, false);
  }
};

gravity.loginForms = function() {
  function showRecoverPasswordForm() {
    gravity.cache.$recoverPasswordForm.show();
    gravity.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    gravity.cache.$recoverPasswordForm.hide();
    gravity.cache.$customerLoginForm.show();
  }

  gravity.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  gravity.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (gravity.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

gravity.resetPasswordSuccess = function() {
  gravity.cache.$passwordResetSuccess.show();
};


gravity.zoomInit = function (imgZoom) {
  if (imgZoom.length && $(window).width() > 1024 ) {
    imgZoom
      .parent()
      .zoom({
        url: imgZoom.parent().attr('data-zoom')
    });
  }
}

gravity.instagramFeed = function (section) {

  var instagramContainer = $(section).find('.instagram-widget'),
      photosGridContainer = $(section).find('.instagram__grid'),
      instagramLoader = $(section).find('.instagram__grid_loader');
  var photosCount = instagramContainer.attr('data-insta-count'),
      token = instagramContainer.attr('data-insta-token'),
      showCaption = instagramContainer.attr('data-insta-caption');

  if( token.length ) {
    $.ajax({
      url: 'https://api.instagram.com/v1/users/self/media/recent',
      dataType: 'jsonp',
      type: 'GET',
      data: {access_token: token, count: photosCount},
      success: function(data){
          var photoItemHtml = '';
          for( x in data.data ){
            var date = new Date(data.data[x].created_time * 1000);
            var photoTimestamp = date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric'});

            var imageResolution = data.data[x].images.standard_resolution;
            var scaleClass = imageResolution.width > imageResolution.height ? 'photo__image_y' : 'photo__image_x';

            photoItemHtml += '<div class="column"><div class="instagram__photo-wrap"><div class="instagram__photo">';
            photoItemHtml += '<a class="photo__link" href="' + data.data[x].link + '" target="_blank"></a>';
            photoItemHtml += '<img class="photo__image ' + scaleClass + '" src="' + data.data[x].images.standard_resolution.url + '">';
            photoItemHtml += '</div></div></div>';

            photosGridContainer.html(photoItemHtml);
          }
      },
      error: function(data){
          console.log(data);
      }
    });
  }
};

//GOOGLE MAP
gravity.newMap = function ( jQueryel, location ) {

  var map = new google.maps.Map(jQueryel[0], {
    zoom: 14,
    disableDefaultUI: true,
    center: location,
    scrollwheel: false,
    zoomControl: true,
    zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER
    }
  });
  var marker = new google.maps.Marker({
    position: location,
    map: map
  });

  return map;
}

gravity.geolocate = function (jQueryel) {
  var geocoder = new google.maps.Geocoder();
  var address = $(jQueryel[0]).attr('data-address-setting');

  geocoder.geocode({ address: address }, function(results, status) {
    if (status !== google.maps.GeocoderStatus.OK) {
      return false;
    }
    gravity.newMap(jQueryel, results[0].geometry.location);
  });
}

var maps_api_init = 0;
var maps_api_ready = 0;

gravity.mapsInit = function (section) {
  var map = null;
  var mapContainer = $(section).find('.map__container');
  if(mapContainer.length) {
    var api_key = $(mapContainer).attr('data-api-key');
    if(api_key.length && mapContainer.length) {
      if (!maps_api_ready) {
        maps_api_init = 1;
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + api_key
        ).done(function() {
          maps_api_ready = 1;
          $('.map__container').each(function () {
            gravity.geolocate($(this));
          });
        });
      }
    }
  }
};

//YOUTUBE VIDEOS
var youtube_api_ready = 0;

window.onYouTubeIframeAPIReady = function() {
  youtube_api_ready = 1;

  gravity.ytSectionsInit();
}

gravity.ytSectionsInit = function() {
  gravity.loadVideo();

  $('.hero-section_video').each(function () {
    loadBackgroundVideo($(this));
  });
}

gravity.videoApi = function() {
  var tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  $('body').append(tag);
};

window.onBgVideoReady = function (evt) {
  var videoData = $(evt.target.h).attr('id');

  $('#' + videoData).attr('tabindex', '-1');
  evt.target.mute();
  evt.target.playVideo();
  // evt.target.setPlaybackQuality('hd720');
}

window.onPlayerChange = function (evt) {
  if (evt.data == 0) {
    evt.target.seekTo(0);
  }
}

function getVideoOptions(evt) {
  return $('.background__video[data-id=' + evt.target.h.id + ']');
}

window.loadBackgroundVideo = gravity.loadBackgroundVideo = function (section) {
  var bg_video = $(section).find('.background__video');

  if( bg_video.length) {
    bg_video.each( function () {
      var key = $(this).attr('id')
      var video = $(this).attr('data-id');

      var args = {
        ratio: 16 / 9,
        videoId: video,
        playerVars: {
          playsinline: 1,
          cc_load_policy: 0,
          iv_load_policy: 3,
          modestbranding: 0,
          controls: 0,
          showinfo: 0,
          fs: 0,
          wmode: 'opaque',
          branding: 0,
          autoplay: 1,
          autohide: 0,
          quality: 'hd720',
          rel: 0
        },
        events: {
          onReady: onBgVideoReady,
          onStateChange: onPlayerChange
        }
      };

      var videoPlayer = new YT.Player(key, args);

      function setVideoHeight () {
        var videoContainer = $('.background__video[id="'+key+'"]');
        var videoHeight = $(window).width() * 9 / 16;

        videoWrap = videoContainer.parents('.section').first();

        if (videoWrap.outerHeight() < videoHeight) {
          videoContainer.css('width', '100%');
          videoContainer.css('height', $(window).width() * 9 / 16 );
        } else {
          videoContainer.css('width', videoWrap.outerHeight() * 16 / 9 );
          videoContainer.css('height', '200%' );
        }
      }

      setVideoHeight();
      $(window).resize( function () {
        setVideoHeight();
      });

    });
  }
}

window.onVideoReady = function(evt) {
  var videoData = getVideoOptions(evt);
  var videoCover = $('#' + evt.target.h.id).parents().first().find('.video__cover').first();
  evt.target.setPlaybackQuality('hd1080');

  videoCover.find('.video__play-button').click( function () {
    videoCover.hide();
    $('#' + evt.target.h.id).addClass('youtube-video_started');
    evt.target.playVideo();
  });
}

gravity.loadVideo = function () {
  var yt_video = $('.video-section .video__iframe');
  if( yt_video.length) {
    yt_video.each( function () {
      var key = $(this).attr('id');
      var video = $(this).attr('data-id');
      var args = {
        ratio: 16 / 9,
        videoId: video,
        playerVars: {
          iv_load_policy: 3,
          modestbranding: 1,
          rel: 0
        },
        events: {
          onReady: onVideoReady
        }
      };

      var videoPlayer = new YT.Player(key, args);

      function setVideoHeight () {
        var videoContainer = $('.video__iframe[id="'+key+'"]');
        var videoHeight = videoContainer.width() * 9 / 16;
        videoContainer.css('height', videoHeight);
      }

      setVideoHeight();
      $(window).resize( function () { setVideoHeight(); });
    });
  }
}

gravity.productPageLoad = function (section) {
  var productImages = $('#productImages'),
  infoTabs = $(section).find('#ProductTabs');

  if(infoTabs.length) {
    descriptionTabs = new Foundation.Tabs(infoTabs);
  }

  // Product Images Carousel
  if(productImages.length && productImages.first().hasClass('is-carousel')) {

    if($('.product-page_default').length) {
      if(productImages.find('.product-image__slide').length > 2 ) {
        var slidesVisible = 3;
      } {
        var slidesVisible = 1;
      }

      productImages.slick({
         arrows: false,
         mobileFirst: true,
         centerMode: true,
         centerPadding: '50px',
         adaptiveHeight: true,
         slidesToShow: 1,
         focusOnSelect: true,
         infinite: false,
         responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: slidesVisible,
              variableWidth: true
            }
          },
          {
            breakpoint: 1024,
            settings: {
              arrows: true,
              centerMode: true,
              slidesToShow: slidesVisible,
              variableWidth: true
            }
          }
         ]
        }
      );
      $(window).on('orientationchange', function() {
        $(productImages).slick('resize');
      });
    }

    if($('.product-page_alt').length) {
      productImages.slick({
         arrows: false,
         adaptiveHeight: true,
         infinite: false,
         initialSlide: 0,
         fade: true,
         cssEase: 'linear',
         responsive: [
           {
             breakpoint: 750,
             settings: {
               arrows: false,
               centerMode: true,
               centerPadding: '40px',
               slidesToShow: 1,
               focusOnSelect: true,
               fade: false
             }
           }
         ]
      });

      $('#ProductThumbs .product__thumb').click(function () {
       var thumb = $(this)
       if(!thumb.hasClass('active')) {
         var newImageId = thumb.attr('data-thumb-id');
         gravity.changeFeaturedImg(newImageId);
       }
      });
    }

    productImages.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      

      if($('.product-page_alt').length) {
        var newActiveThumb = $('.product__thumb:eq('+nextSlide+')');
        if (!newActiveThumb.hasClass('active')) {
          $('.product__thumb.active').removeClass('active');
          $('.product__thumb:eq('+nextSlide+')').addClass('active');
        }
      }
    });
  }
};

gravity.featuredCarousel = function (section) {
  var featuredGrid = $(section).find('.featured__grid');

  if($(featuredGrid).hasClass('featured-carousel')) {
    gravity.mobileCarouselInit($(featuredGrid));
    gravity.featuredCarouselControls($(featuredGrid));
    gravity.featuredCarouselSettle($(featuredGrid));
    $(window).resize( function() {
      gravity.mobileCarouselInit($(featuredGrid));
      gravity.featuredCarouselControls($(featuredGrid));
      gravity.featuredCarouselSettle($(featuredGrid));
    });

    if (!featuredGrid.data('featured-carousel-load-bound')) {
      featuredGrid.data('featured-carousel-load-bound', true);
      $(window).on('load', function() {
        gravity.featuredCarouselSettle(featuredGrid);
      });
    }
  }
}

gravity.featuredCarouselControls = function (carousel) {
  var realSlideCount = carousel.find('.product-loop-item').length;
  var controls = carousel.siblings('.featured-carousel__controls');

  if ($(window).width() >= 1024 || realSlideCount <= 1) {
    controls.remove();
    return;
  }

  if (!controls.length) {
    controls = $(
      '<div class="featured-carousel__controls">' +
        '<button class="featured-carousel__button featured-carousel__button--prev" type="button" aria-label="Previous products">‹</button>' +
        '<button class="featured-carousel__button featured-carousel__button--next" type="button" aria-label="Next products">›</button>' +
      '</div>'
    );
    carousel.after(controls);

    controls.find('.featured-carousel__button--prev').on('click', function() {
      gravity.featuredCarouselGoTo(carousel, -1);
    });

    controls.find('.featured-carousel__button--next').on('click', function() {
      gravity.featuredCarouselGoTo(carousel, 1);
    });
  }

  gravity.featuredCarouselUpdateControls(carousel);

  if (!carousel.data('featured-carousel-controls-bound')) {
    carousel.data('featured-carousel-controls-bound', true);
    carousel.on('afterChange', function() {
      gravity.featuredCarouselUpdateControls(carousel);
    });
  }
}

gravity.featuredCarouselGoTo = function (carousel, direction) {
  if (!carousel.hasClass('slick-initialized')) return;

  var realSlideCount = carousel.find('.product-loop-item').length;
  var maxIndex = gravity.featuredCarouselMaxIndex(carousel, realSlideCount);
  var currentIndex = carousel.slick('slickCurrentSlide');
  var nextIndex = Math.max(0, Math.min(currentIndex + direction, maxIndex));

  carousel.slick('slickGoTo', nextIndex, false);
  gravity.featuredCarouselUpdateControls(carousel);
}

gravity.featuredCarouselUpdateControls = function (carousel) {
  var controls = carousel.siblings('.featured-carousel__controls');
  if (!controls.length) return;

  var realSlideCount = carousel.find('.product-loop-item').length;
  var maxIndex = gravity.featuredCarouselMaxIndex(carousel, realSlideCount);
  var currentIndex = carousel.hasClass('slick-initialized') ? carousel.slick('slickCurrentSlide') : 0;

  if (currentIndex > maxIndex && carousel.hasClass('slick-initialized')) {
    carousel.slick('slickGoTo', maxIndex, true);
    currentIndex = maxIndex;
  }

  controls.find('.featured-carousel__button--prev').prop('disabled', currentIndex <= 0);
  controls.find('.featured-carousel__button--next').prop('disabled', currentIndex >= maxIndex);
}

gravity.featuredCarouselMaxIndex = function (carousel, realSlideCount) {
  if (!carousel.hasClass('slick-initialized')) {
    return Math.max(realSlideCount - 1, 0);
  }

  var slick = carousel.slick('getSlick');
  var slidesToShow = slick && slick.options ? parseFloat(slick.options.slidesToShow) : 1;
  return Math.max(Math.ceil(realSlideCount - slidesToShow), 0);
}

gravity.featuredCarouselSettle = function (carousel) {
  function settle() {
    if (carousel.hasClass('slick-initialized')) {
      carousel.slick('setPosition');
      carousel.slick('slickGoTo', carousel.slick('slickCurrentSlide'), true);
    }
  }

  settle();
  setTimeout(settle, 50);
  setTimeout(settle, 250);
}

gravity.mobileCarouselInit = function (carousel) {
  if ($(window).width() >= 1024) {
    if (carousel.hasClass('slick-initialized')) {
      carousel.slick('unslick');
    }
    return;
  }
  if (!carousel.hasClass('slick-initialized')) {
    carousel.slick({
      adaptiveHeight: true,
      infinite: false,
      mobileFirst: true,
      arrows: false,
      accessibility: true,
      centerMode: false,
      centerPadding: '14px',
      slidesToShow: 1.5,
      slidesToScroll: 1,
      focusOnSelect: true,
      draggable: true,
      swipe: true,
      touchMove: true,
      responsive: [
       {
         breakpoint: 750,
         settings: {
           centerMode: false,
           centerPadding: '9px',
           slidesToShow: 2.5,
           slidesToScroll: 1
         }
       },
       {
         breakpoint: 1024,
         settings: "unslick"
       }
      ]
    });
  }
}

//Content Animations
var scrollMagicController = new ScrollMagic.Controller();

gravity.animateAppear = function (element, appearStyle) {
  elem = $(element).get(0);

  if ($(elem).length) {
    switch (appearStyle) {
      case 'show':
        var tween = TweenMax.to(elem, 0.7, {opacity:1});
        break;
      case 'up':
        var tween = TweenMax.fromTo(elem, 0.5, {y:'50px'}, {opacity:1, y:0});
        break;
      case 'left':
        var tween = TweenMax.fromTo(elem, 0.7, {x:'-50px'}, {opacity:1, x:0});
        break;
      case 'right':
        var tween = TweenMax.fromTo(elem, 0.7, {x:'50px'}, {opacity:1, x:0});
        break;
      default:
        break;
    }

    var showScene = new ScrollMagic.Scene({
        offset: 30,
        triggerElement: elem,
        reverse: false,
        triggerHook: 1
    })
      .setTween(tween)
      .addTo(scrollMagicController);
  }
};

gravity.pageSections = function (section) {
  //Featured Products
  $('div[data-block-type="featured-products"]').each(function () {
    gravity.featuredCarousel($(this));
  });

  //Instagram Feed
  $(section).find('div[data-block-type="instagram-feed"]').each(function () {
    gravity.instagramFeed($(this));
  });

  //Google Maps
  $('div[data-block-type="google-map"]').each(function () {
    if (maps_api_ready) {
      $('.map__container').each(function () {
        gravity.geolocate($(this));
      });
    } else {
      if (!maps_api_init) {
        gravity.mapsInit($(this));
      }
    }
  });

  //Embedded product
  $('.product-page_embedded').each(function () {
    gravity.productPageLoad($(this));
  });

  //YouTube videos
  if ($('.background__video, .video__iframe').length) {
    if (youtube_api_ready) {
      if ($('div[data-block-type="youtube-video"]').length ) {
        gravity.loadVideo();
      }
      $('div[data-block-type="hero"]').each(function () {
        if($(this).hasClass('hero-section_video')) {
          gravity.loadBackgroundVideo($(this));
        }
      });
    } else {
      if (!$('script[src="https://www.youtube.com/iframe_api"]').length) {
        gravity.videoApi();
      }
    }
  }

  gravity.animatedIconsInit();
};

/*============================================================================
  Animated Icons
==============================================================================*/
gravity.animatedIconsInit = function () {
  
}

/*============================================================================
  Sections Init
==============================================================================*/
var sections = new theme.Sections();

$(document).ready(function() {
  gravity.init();

  sections.register('hero', function (section) {
    if( $(section).hasClass('hero-section_video')) {
      if (youtube_api_ready) {
        gravity.loadBackgroundVideo(section);
      } else {
        if (!$('script[src="https://www.youtube.com/iframe_api"]').length) {
          gravity.videoApi();
        }
      }
    }
  });

  sections.register('header', function (section) {
    var headerAttrs = JSON.stringify(getAttributes($('#shopify-section-header')));
    if (headerAttrs.indexOf("data-theme-editor-section") >= 0) {
      if(!$('body').hasClass('editor-page')) {
        $('body').addClass('editor-page');
      }
    }
    gravity.headerInit(section);

    //Google Maps
    $('div[data-block-type="mega-menu-google-map"]').each(function () {
      if (maps_api_ready) {
        $('.map__container').each(function () {
          gravity.geolocate($(this));
        });
      } else {
        if (!maps_api_init) {
          gravity.mapsInit($(this));
        }
      }
    });

    gravity.animatedIconsInit();
  });

  sections.register('product-page', function (section) {
    gravity.productPageLoad(section);
  });

  sections.register('featured-products', function (section) {
    gravity.featuredCarousel(section);
  });

  sections.register('related-products', function (section) {
    gravity.featuredCarousel(section);
  });

  sections.register('featured-collections', function (section) {
    gravity.featuredCarousel(section);
  });

  sections.register('instagram-feed', function (section) {
    gravity.instagramFeed(section);
  });

  sections.register('google-map', function (section) {
    if (maps_api_ready) {
      $('.map__container').each(function () {
        gravity.geolocate($(this));
      });
    } else {
      if (!maps_api_init) {
        gravity.mapsInit(section);
      }
    }
  });

  var pageTemplateSection = sections.register('page-template', function (section) {
    gravity.pageSections(section);
  });

  sections.register('youtube-video', function (section) {
    if (youtube_api_ready) {
      gravity.loadVideo();
    } else {
      if (!$('script[src="https://www.youtube.com/iframe_api"]').length) {
        gravity.videoApi();
      }
    }
  });

  function getAttributes ( $node ) {
    var attrs = {};
    $.each($node[0].attributes, function ( index, attribute ) {
      attrs[attribute.name] = attribute.value;
    });
    return attrs;
  }

  $(document).on('shopify:section:select', function () {
    if(!$('body').hasClass('editor-page')) {
      $('body').addClass('editor-page');
    }
  });

  if(!$('editor-page').length) {
    $('.js-animate-appear-left').each(function(index, elem){
      gravity.animateAppear(elem, 'left');
    });

    $('.js-animate-appear-right').each(function(index, elem){
      gravity.animateAppear(elem, 'right');
    });

    $('.js-animate-appear-show').each(function(index, elem){
      gravity.animateAppear(elem, 'show');
    });

    $('.js-animate-appear-up').each(function(index, elem){
      gravity.animateAppear(elem, 'up');
    });
  }

  if($('.editor-page').length) {
    sections.register('features', function (section) {
      gravity.animatedIconsInit();
    });
    sections.register('image-text', function (section) {
      gravity.animatedIconsInit();
    });
    sections.register('cta-section', function (section) {
      gravity.animatedIconsInit();
    });
  }
});
